import { Injectable, isDevMode as angularIsDevMode } from "@angular/core";

/* eslint-disable  @typescript-eslint/no-explicit-any */

export enum LogLevel {
    DEBUG = 1,
    INFO = 2,
    WARN = 3,
    ERROR = 4,
    NONE = 5,
}

@Injectable({
    providedIn: 'root',
})
export class LoggerService {

    private defaultLogLevel = LogLevel.ERROR;

    public isDevMode(): boolean {
        return angularIsDevMode();
    }

    public getScopedLogger(componentName: string) {
        return {
            debug: (...args: any[]) => this.debug(componentName, ...args),
            info: (...args: any[]) => this.info(componentName, ...args),
            warn: (...args: any[]) => this.warn(componentName, ...args),
            error: (...args: any[]) => this.error(componentName, ...args),
        };
    }

    private componentLogLevels = new Map<string, LogLevel>();

    setLogLevel(componentName: string, level: LogLevel) {
        this.componentLogLevels.set(componentName, level);
    }

    private getLogLevel(componentName: string): LogLevel {
        return this.componentLogLevels.get(componentName) ?? this.defaultLogLevel;
    }

    info(componentName: string, ...args: any[]): void {
        if (this.isDevMode() && this.getLogLevel(componentName) <= LogLevel.INFO) {
            console.log(`[INFO][${componentName}]`, ...args);
        }
    }

    debug(componentName: string, ...args: any[]): void {
        if (this.isDevMode() && this.getLogLevel(componentName) <= LogLevel.DEBUG) {
            console.debug(`[DEBUG][${componentName}]`, ...args);
        }
    }

    warn(componentName: string, ...args: any[]): void {
        if (this.getLogLevel(componentName) <= LogLevel.WARN) {
            console.warn(`[WARN][${componentName}]`, ...args);
        }
    }

    error(componentName: string, ...args: any[]): void {
        if (this.getLogLevel(componentName) <= LogLevel.ERROR) {
            console.error(`[ERROR][${componentName}]`, ...args);
        }
    }
}
